/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { Modal, Input, Switch, Checkbox, Row, Col } from 'antd'

export default class extends React.Component {
  //选中区域
  checkboxId = (item) => {
    let wallet_id = []
    item &&
      item.map((list) => {
        if (list.access == 1) {
          wallet_id.push(list.id)
        }
      })
    return wallet_id
  }

  onChange = (value) => {
    let type = 0
    if (value) {
      type = 1
    }
    return type
  }

  render() {
    const { visible, record, action, walletType } = this.props
    return (
      <div>
        <Modal
          title={action === '-1' ? '添加钱包' : '修改钱包'}
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <div style={{ marginBottom: '2rem' }}>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">钱包名称:</span>
              <Input
                size="large"
                defaultValue={record.name}
                style={{ width: '50%', marginLeft: '1rem' }}
                placeholder="请输入钱包名称"
                onChange={(e) =>
                  sessionStorage.setItem('name', e.target.value)
                }
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否禁用:</span>
              <Switch
                defaultChecked={record.del == '1' ? true : false}
                onChange={(value) =>
                  sessionStorage.setItem('del', this.onChange(value))
                }
                style={{ marginLeft: '3.5rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否可以直接支付:</span>
              <Switch
                defaultChecked={record.permit == '1' ? true : false}
                onChange={(value) =>
                  sessionStorage.setItem('permit', this.onChange(value))
                }
                style={{ marginLeft: '.5rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否可以购买商品:</span>
              <Switch
                defaultChecked={record.commodity == '1' ? true : false}
                onChange={(value) =>
                  sessionStorage.setItem('commodity', this.onChange(value))
                }
                style={{ marginLeft: '.5rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否可以前台充值:</span>
              <Switch
                defaultChecked={record.recharge == '1' ? true : false}
                onChange={(value) =>
                  sessionStorage.setItem('recharge', this.onChange(value))
                }
                style={{ marginLeft: '.5rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否可以自助充值:</span>
              <Switch
                defaultChecked={
                  record.self_recharge
                    ? record.self_recharge == '1'
                      ? true
                      : false
                    : true
                }
                onChange={(value) =>
                  sessionStorage.setItem('self_recharge', this.onChange(value))
                }
                style={{ marginLeft: '.5rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否可以支付服务费:</span>
              <Switch
                defaultChecked={
                  record.can_pay_service_charge == '1' ? true : false
                }
                onChange={(value) =>
                  sessionStorage.setItem(
                    'can_pay_service_charge',
                    this.onChange(value)
                  )
                }
                style={{ marginLeft: '.5rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">是否可以前台消费:</span>
              <Switch
                defaultChecked={record.consumable == '1' ? true : false}
                onChange={(value) =>
                  sessionStorage.setItem('consumable', this.onChange(value))
                }
                style={{ marginLeft: '2rem' }}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">选择钱包消费区域(可以不勾选):</span>
              <Checkbox.Group
                defaultValue={this.checkboxId(record.classify)}
                onChange={(value) => this.props.handleEditCheckbox(value)}
                style={{ padding: '.5rem 0 0 .5rem' }}
              >
                <Row>
                  {walletType &&
                    walletType.map((item, idx) => {
                      return (
                        <Col span={6} key={idx}>
                          <Checkbox value={item.id}>{item.name}</Checkbox>
                        </Col>
                      )
                    })}
                </Row>
              </Checkbox.Group>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubWallet/component/modal.js